import { IComponentColumn } from 'src/app/core/parts/components/components.interfaces';
import { actionMenu, GridHeaderData } from 'src/app/shared/shared.interface';
import { PartDetailshComponent } from '../../../components/part-details/part-details.component';
import { ViewComponentComponent } from '../components/view-component/view-component.component';

export const headers: GridHeaderData[] = [
  {
    actions: [
      {
        componentData: {
          componentTilte: 'View Component',
          componentName: ViewComponentComponent,
          open: true,
        },
        actionType: actionMenu.view,
      }
    ],
    field: 'Actions',
    title: '',
    width: 80
  }, 
  {
    field: 'CM',
    title: 'CM',
    filterable: true,
    sortable: true,
    width: 120
  }, 
  {
    field: 'PartNumber',
    title: 'Part Number',
    filterable: true,
    sortable: false,
    width: 180
  },
  {
    field: 'SiteName',
    title: 'Site Name',
    filterable: true,
    sortable: false,
    width: 200
  },
  {
    field: 'EAU',
    title: 'EAU',
    filterable: true,
    sortable: false,
    width: 120
  },
  {
    field: 'CurrentSupplier',
    title: 'Current Supplier',
    filterable: true,
    sortable: false,
    width: 220
  },
  {
    field: 'CurrentManufacturer',
    title: 'Current Manufacturer',
    filterable: true,
    sortable: false,
    width: 220
  },
  {
    field: 'ManufacturerPartNumber',
    title: 'Manufacturer Part Number',
    filterable: true,
    sortable: false,
    width: 240
  },
  {
    field: 'SEManufacture',
    title: 'SE Manufacture',
    filterable: true,
    sortable: false,
    width: 200
  },
  {
    field: 'SEMPN',
    title: 'SE MPN',
    filterable: true,
    sortable: false,
    width: 180
  },
  {
    field: 'Description',
    title: 'Description',
    filterable: true,
    sortable: false,
    width: 400
  },
  {
    field: 'CurrentUnitPrice',
    title: 'Current Unit Price',
    filterable: true,
    sortable: false,
    width: 180
  },
  {
    field: 'MOQ',
    title: 'MOQ',
    filterable: true,
    sortable: false,
    width: 120
  },
  {
    field: 'UOM',
    title: 'UOM',
    filterable: true,
    sortable: false,
    width: 120
  },
  {
    field: 'Commodity',
    title: 'Commodity',
    filterable: true,
    sortable: false,
    width: 180
  },
  {
    field: 'CommodityType',
    title: 'Commodity Type',
    filterable: true,
    sortable: false,
    width: 200
  },
  {
    field: 'CustomSoleSource',
    title: 'Custom / Sole source',
    filterable: true,
    sortable: false,
    width: 200
  },
  {
    field: 'Spend',
    title: 'Spend',
    filterable: true,
    sortable: false,
    width: 140
  },
  {
    field: 'CurrentStock',
    title: 'Current Stock',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'Remarks',
    title: 'Remarks',
    filterable: true,
    sortable: false,
    width: 240
  },
  {
    field: 'SELifeCycleStatus',
    title: 'SE Life cycle Status',
    filterable: true,
    sortable: false,
    width: 220
  },
  {
    field: 'SEAVGPrice',
    title: 'SE AVG Price',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'SEInventory',
    title: 'SE Inventory',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'SELT',
    title: 'SE LT (Weeks)',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'ACL',
    title: 'ACL',
    filterable: true,
    sortable: false,
    width: 120
  },
  {
    field: 'AML',
    title: 'AML',
    filterable: true,
    sortable: false,
    width: 120
  },
  {
    field: 'SnappedPrice',
    title: 'Snapped Price',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'Price',
    title: 'Price',
    filterable: true,
    sortable: false,
    width: 140
  },
  {
    field: 'PriceDiff',
    title: 'Price Diff',
    filterable: true,
    sortable: false,
    width: 140
  },
  {
    field: 'SnappedQTY',
    title: 'Snapped QTY',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'QTY',
    title: 'QTY',
    filterable: true,
    sortable: false,
    width: 140
  },
  {
    field: 'QTYDiff',
    title: 'QTY Diff',
    filterable: true,
    sortable: false,
    width: 140
  },
  {
    field: 'SnappedLeadTime',
    title: 'Snapped Lead Time',
    filterable: true,
    sortable: false,
    width: 200
  },
  {
    field: 'LeadTime',
    title: 'Lead Time',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'LeadTimeDiff',
    title: 'Lead Time Diff',
    filterable: true,
    sortable: false,
    width: 180
  },
  {
    field: 'Spot',
    title: 'Spot buy is lower than negotiated',
    filterable: true,
    sortable: false,
    width: 300
  },
  {
    field: 'SafetyStockLevel',
    title: 'Safety Stock Level',
    filterable: true,
    sortable: false,
    width: 220
  },
  {
    field: 'CriticalPart',
    title: 'Critical Part',
    filterable: true,
    sortable: false,
    width: 160
  },
  {
    field: 'PartFamily',
    title: 'Part Family',
    filterable: true,
    sortable: false,
    width: 180
  }
];



export function getGridViewHearders(dynamicColumns: IComponentColumn[] = []): any[] {
  return [
    {
      actions: [
        {
          componentData: {
            componentTilte: '',
            componentName: PartDetailshComponent,
            open: true,
          },
          actionType: actionMenu.view,
        }
      ],
      field: 'Actions',
      title: 'Actions',
      locked: true,
      width: 72

    },
    ...dynamicColumns?.map((c: any) => {
      if(c.partsFeatureName == "CM")
      {
        return {
          field: c.colAlias,
          title: c.partsFeatureName,
          filterColName:c.colName,
          filterable: true,
          sortable: true,
          locked: true,
          multiSelect:c.multiSelect,
          width: 72
        };
      }
      else if(c.partsFeatureName == "CM PN" || c.partsFeatureName == "TF PN")
      {
        return {
          field: c.colAlias,
          title: c.partsFeatureName,
          filterColName:c.colName,
          filterable: true,
          sortable: true,
          locked: true,
          multiSelect:c.multiSelect,
          width: 120
        };
      }
      else 
       return {
        field: c.colAlias,
        title: c.partsFeatureName,
        filterColName:c.colName,
        filterable: true,
        sortable: true,
        multiSelect:c.multiSelect
      };
    }),
 
    
  ];
}